<template lang="html">
  <DetailedListing :preupload="true" />
</template>

<script>
import DetailedListing from './detailed_listing/DetailedListing.vue'
export default {
  components: { DetailedListing }
}
</script>

<style lang="css" scoped>
</style>
